// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ni5Bf","all_link":"_3opCy","list":"_2BtTM"};